<div  [ngStyle]="{'background-color':color?.PrimaryColor}" (scroll)="onScroll($event)" style="background-color:rgb(234,250,254);overflow-y: scroll ;max-height:100% ;" >
    <!--(scroll)="onScroll($event)"  -->
    <!-- (scroll)="onScroll($event)" style="background-color:rgb(234,250,254);overflow-y: scroll ;max-height:100% ;" -->
    <span #tops></span>
  
  <app-flight  style="font-size: small;" [class]="pointerEvents?('pointerEventsNone'):''" (myOutput)="searchFlight()" ></app-flight>
  
  <div class=" col-lg-12  " style="max-width: 100%; margin-top: -80px;position: relative;  width:100%;"  > 
  <div class=" col-md-12 " style="margin-top: 20px;">
   

   
  <div  *ngIf="returnflight"   class="col-md-12">
  
    
    
    <!--##############filter#################=============================================================================-->
  <!--###################################   filter ##################################################
       ###################################  filter ################################################## 
        ################################### filter ##################################################-->
        <mat-expansion-panel   hideToggle disabled class=" sticky-tabs" style=" margin-left: 20px; margin-right: 20px; min-width:1200px ; min-height: 50px;">
     
          <mat-expansion-panel-header style="background-color: transparent;">
          
            <mat-panel-title style="background-color: transparent;">
              
              <div class="col-md-12 row  bold " style="color:rgb(32,32,32); font-size: 18px;">
              
                  <div  [class]="rules?('col-md-12  d-flex justify-content-end'):'col-md-12  d-flex justify-content-end'" >
                    <span *ngIf="rules" style="color: 017BFE;font-size: 13px;white-space: nowrap;padding-top: 10px;">
                      <p-checkbox 
              [(ngModel)]="Incv" 
              [binary]="true" 
              inputId="binary" 
              label="Show Incv"/> 
  <span style="padding-right: 8px; padding-left: 5px; ">
              <p-checkbox 
              [(ngModel)]="net" 
              [binary]="true" 
              inputId="binary" 
              label="Show Net"/> 
            </span>
            </span>
                
              <span class="mt-2" style="white-space: nowrap;">
              <span style="color:#007bff;font-size: small;">Sort : </span>
              &nbsp;
              <span class="hoverLine" style="color:#007bff ;font-size: small;" (click)="combineFlilter('airline')">Airlines</span>
              &nbsp;
              <span class="hoverLine" style="color:#007bff ;font-size: small;" (click)="combineFlilter('departs')">Departs</span>
              &nbsp;
              <span class="hoverLine" style="color:#007bff ;font-size: small;"(click)="combineFlilter('arrives')" >Arrives</span>
              &nbsp;
              <span class="hoverLine" style="color:#007bff ;font-size: small;"(click)="combineFlilter('price')" >Price</span>
              &nbsp;
              &nbsp;
  
  
            </span>
                    <div class=" "   style="min-width:100px; padding: 4px; margin-right: 8px;" >
                      <mat-slide-toggle (click)="enableCheckBox()" [(ngModel)]="enableCheck">
                        <button  mat-button disabled *ngIf="!enableCheck" ><mat-icon>share</mat-icon>Share</button>
                        <button [matMenuTriggerFor]="showShareDialog" aria-label="Example icon-button with a menu" mat-raised-button *ngIf="enableCheck" ><mat-icon>share</mat-icon>Share</button>
                      </mat-slide-toggle>
                    
                    
                      <mat-menu #showShareDialog="matMenu"  >
                        <!-- <button mat-menu-item (click)="shareEmailPopup()">
                          <mat-icon style="margin-right: 60px;"> insert_link</mat-icon>
                          <span>Link</span>
                        </button> -->
                        <button mat-menu-item (click)="sendAllData()">
                          <mat-icon style="margin-right: 60px;">done_all</mat-icon>
                          <span>All</span>
                        </button>
                        <!-- <button mat-menu-item (click)="shareEmailPopup()">
                          <mat-icon style="margin-right: 60px;">filter_list</mat-icon>
                          <span>Filter</span>
                        </button> -->
                        <button mat-menu-item (click)="sendSelectedData()">
                          <mat-icon style="margin-right: 60px;"> playlist_add_check</mat-icon>
                          <span>Selected</span>
                        </button>
                       
                      </mat-menu> 
                    </div> 
  
  
                    <div class="d-flex justify-content-end" style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{minPrice}}</div>
  
                    <div class=" " style="min-width:100px;  margin:0;  margin-top:-4px ; padding: 0;"  > 
                       <mat-slider     
                      style="margin: 0;padding: 0;  "
                      class="example-margin"
                      [max]="maxPrice"
                      [min]="minPrice"
                      step="0"
                      [discrete]="'true'"
                      [showTickMarks]="'false'">
                    <input matSliderThumb [(ngModel)]="value" (input)="combineFilters()" #slider>
                  </mat-slider></div> 
  
                    <div style="min-width:100px; padding: 4px; margin-right: 8px; " >₹{{maxPrice}}</div>
                    
                    <div class=" "style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="showTimeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Time </button>
                      
                      <mat-menu #showTimeDialog="matMenu"  >
                        <mat-selection-list [(ngModel)]="filterTime" (click)="combineFilters()" (click)="onMenuClick($event)">
                          <mat-list-option color="primary" checkboxPosition="before" value="earlyMorning"  style="font-size: 12px;">Early morning  <small style="font-size: xx-small;">(Midnight - 8AM)</small></mat-list-option>
                         
                          <mat-list-option color="primary" checkboxPosition="before" value="morning" style="font-size: 12px;">Morning <small style="font-size: xx-small;">(8AM-Noon)</small></mat-list-option>
                          <mat-list-option color="primary" checkboxPosition="before" value="afternoon" style="font-size: 12px;">Afternoon <small style="font-size: xx-small;">(Noon - 4PM)</small></mat-list-option>
                          <mat-list-option color="primary" checkboxPosition="before" value="evening" style="font-size: 12px;">Evening <small style="font-size: xx-small;">(4PM - 8PM)</small></mat-list-option>
                          <mat-list-option color="primary" checkboxPosition="before" value="night" style="font-size: 12px;">Night <small style="font-size: xx-small;">(8PM - Midnight)</small></mat-list-option>
                  
                          </mat-selection-list>
                      </mat-menu> </div> 
                    <div class=" "  style="padding: 4px; margin-right: 8px; " [matMenuTriggerFor]="OpenDialog" aria-label="Example icon-button with a menu"><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Stops </button>
                      <mat-menu #OpenDialog="matMenu" >
                        <mat-selection-list [(ngModel)]="stop" (click)="combineFilters()" (click)="onMenuClick($event)">
                          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers" [value]="1" style="font-size: 12px;">Non-stop</mat-list-option>
                          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size <= 3 && uniqueNumbers.size >= 2" value="2" style="font-size: 12px;">1 stop</mat-list-option>
                          <mat-list-option color="primary" checkboxPosition="before" *ngIf="uniqueNumbers.size === 3" value="3" style="font-size: 12px;">2 stop</mat-list-option>
                
                      </mat-selection-list>
                      </mat-menu>
                    </div> 
                    <div class=" " style="padding: 4px; margin-right: 8px;" [matMenuTriggerFor]="OpenAirDialog" aria-label="Example icon-button with a menu" ><button mat-raised-button><mat-icon>arrow_drop_down</mat-icon>Airlines </button>
                      <mat-menu #OpenAirDialog="matMenu" >
                        <mat-selection-list  [(ngModel)]="airlines" (click)="combineFilters()" (click)="onMenuClick($event)">
                          <mat-list-option color="primary" checkboxPosition="before"  *ngFor="let flightName of uniqueFlightName" [value]="flightName" style="font-size: 12px;">{{fligthNameFilter(flightName)}}({{flightName}})</mat-list-option>
                          
                      </mat-selection-list>
                      </mat-menu>
                    </div> 
                    <div class=" " style="min-width:100px; padding: 4px; margin-right: 8px;"  [matMenuTriggerFor]="OpenfareTypeDialog" aria-label="Example icon-button with a menu"><button mat-raised-button  ><mat-icon>arrow_drop_down</mat-icon> Fare&nbsp;Type</button>
                    
                      <mat-menu #OpenfareTypeDialog="matMenu" >
                        <mat-selection-list [(ngModel)]="fareType" (click)="combineFilters()" (click)="onMenuClick($event)">
                          <mat-list-option color="primary" *ngFor="let item of fareTypeMenu" checkboxPosition="before" [value]="item" style="font-size: 12px;">{{item}}</mat-list-option>
                        
                      </mat-selection-list>
                      </mat-menu>
                    
                    </div> 
      
                    
                   
                   
                  </div>  
              </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
         
        </mat-expansion-panel>
          <!--##############OneWay#################=============================================================================-->
  <!--###################################   OneWay ##################################################
       ###################################  OneWay ################################################## 
        ################################### OneWay ##################################################-->
  <span >
    
    <div style=" min-width:1300px;white-space: nowrap; padding-top: 20px;"  >
      <!-- [expanded]="true" hideToggle  disabled="true"
      (click)="setStep(1);" --> 
      <!-- <cdk-virtual-scroll-viewport *cdkVirtualFor itemSize="50" class="example-viewport"> -->

      <span *ngFor="let fly of visibleflights " style="border: 2px solid #E0D2D1;;">
      <mat-accordion  class="example-headers-align" multi style="padding-top: 10px; " >
        <!-- [ngClass]="{'active' :fly.selected}" -->
    <mat-expansion-panel   *ngFor="let item of fly.itineraries ;let in=index"  [expanded]="fly.selected" [ngClass]="{'set_margin_top' :fly.selected}" disabled hideToggle          style="margin-top: 0;margin-top: 0;;  margin-left: 20px; margin-right: 20px; ">
      <mat-expansion-panel-header  style="padding-top: 37px; padding-bottom: 55px; display: flex;align-items: center;">
  
        <mat-panel-title style="color: rgb(33,33,33); " >
          <div class="col-md-12 row pt-3 pb-1">
            <div class="col-md-2 d-flex justify-content-start pt-4" >
              <img  [src]="flightlogoFilter(item?.flight?.flightDetailsList[0]?.carrierName)" width="30" height="50" alt="">
  
                 
                 
                  <div style="font-size: 14px; min-width: 8%">
                    <div>{{fligthNameFilter(item?.flight?.flightDetailsList[0]?.carrierName)}}</div>
                    <div style="font-size: 13px; color: grey;white-space:nowrap; ">{{item?.flight?.flightDetailsList[0]?.carrierName}}&nbsp;-&nbsp;{{item?.flight?.flightDetailsList[0]?.flightNumber}}<br>
                      
                     <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">  {{carbonPlus(item?.flight?.flightDetailsList)?('CO2 '+(carbonPlus(item?.flight?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{carbonpremiumEconomyPlus(item?.flight?.flightDetailsList)?('CO2 '+(carbonpremiumEconomyPlus(item?.flight?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{carbonfirstPlus(item?.flight?.flightDetailsList)?('CO2 '+(carbonfirstPlus(item?.flight?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{carbonbusinessPlus(item?.flight?.flightDetailsList)?('CO2 '+(carbonbusinessPlus(item?.flight?.flightDetailsList)).toFixed()+' Kg'):'-'}}</span> 
                      <br><span class="bold"  *ngIf="distancePlus(item?.flight?.flightDetailsList)"><mat-icon style="font-size: large;">location_on</mat-icon>{{distancePlus(item?.flight?.flightDetailsList)}}</span>
                    </div>
                  </div>
            </div>
            <div class="col-md-4 pt-4 d-flex justify-content-center" >
                  <div class="col-md-4 bold" >{{item?.flight?.schDepartureTime | date:'HH:mm'}}<br>{{item?.flight?.flightDetailsList[0]?.fromAirport}}</div> 
  
                  <div class="col-md-4"><div class="d-flex justify-content-start" style="padding-left: 10px;">{{converter(item?.flight?.travelDuration)}} 
  
                   
                  </div>
                  <div *ngIf="item?.flight?.hopCount===1" style="border-bottom:2px solid rgb(12, 121, 39) ;max-width: 60%;" ></div>
                  <div *ngIf="item?.flight?.hopCount===2" style="border-bottom:2px solid rgb(235, 235, 124) ;max-width: 60%;"></div>
                  <div *ngIf="item?.flight?.hopCount>2" style="border-bottom:2px solid rgb(219, 81, 71) ;max-width: 60%;"></div>
  
                    <div class="d-flex justify-content-start" *ngIf="item?.flight?.hopCount===1" (click)="popoveritemContent.toggle($event)" style="font-size: 13px; color: grey; padding-left: 10px;">{{item?.flight?.hopCount===1?('non-stop'):''}}</div>
                    <div class="d-flex justify-content-start" *ngIf="item?.flight?.hopCount!=1"  (click)="popoveritemContent.toggle($event)"style="font-size: 13px; color: grey; padding-left: 10px;">&nbsp;&nbsp;{{item?.flight?.hopCount?(item?.flight?.hopCount-1+'-'+'stop'):''}}</div>
  
                    <p-overlayPanel  #popoveritemContent class="col-md-12" [style]="{'max-width':'50rem'}" >
                      <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of item.flight?.flightDetailsList">
                
                <div class="mb-3 mt-1">
                  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
              </div><br>
            <div class="col-md-2">
              <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
          
            
          <br>
          {{fligthNameFilter(element?.carrierName)}}<br>
              <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
                <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
                <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
              
              <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
                <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
                <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
          
              </span>
          </div>
          
          <div class="col-md-2">
              {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
              <br>
              <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
              <br>
              <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
          </div>
          <div class="col-md-2">
              <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
              <br>
              <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
             
          </div>
          <div class="col-md-2">
            {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
              <br>
              <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
              <br>
              <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
          </div>
          <div class="col-md-2">
                  
              
          </div>
          <div class="col-md-2">
             
           </div>
              </div>
            </p-overlayPanel>
  
  
                  </div>
                  <div class="col-md-4 bold">{{item?.flight?.schArrivalTime | date:'HH:mm'}}<br>{{item?.flight?.flightDetailsList[item?.flight?.flightDetailsList.length-1]?.toAirport}}<small style="color: red;font-size: 12px;" ngbPopover="{{item?.flight?.schArrivalTime | date:'dd-MM-yyyy'}}" container="body"
                    triggers="mouseenter:mouseleave">{{calculateDateDifference(item?.flight?.schDepartureTime,item?.flight?.schArrivalTime)}}</small></div>
  
            </div>
             
            <div class="col-md-6 row" >
                      <div *ngIf="fly.itineraries.length===(in+1)" class="col-md-10 pt-3  pb-2 d-flex justify-content-center" >  
                          <div  class="col md-6 row " [style]="fly?.fare[0]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||fly?.fare[0]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||fly?.fare[0]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                                <div *ngIf="fly?.fare[0]" class="col-md-12 row">
                                  <div class="col-md-12 " (click)="setStep(0)" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;"> 
                                    <span *ngIf="!enableCheck"  (click)="onClickFare(fly?.fare[0], fly?.fare,fly)">
                                    <mat-icon class="mat-primary" *ngIf="fly?.fare[0].selected==='true'">radio_button_checked</mat-icon>
                                    <mat-icon style="color: #757575;" *ngIf="fly?.fare[0].selected===''">radio_button_unchecked</mat-icon>
                                    
                                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                                    triggers="mouseenter:mouseleave">
                                    ₹{{fly?.fare[0]?.baseFare+fly?.fare[0]?.finalTax+fly?.fare[0]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{fly?.fare[0]?.netFare}}</span> 
                                   
                                    </span> 
  
                                  </span>    
                                  <span *ngIf="enableCheck" >
                                   
                                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
                                    triggers="mouseenter:mouseleave">
                                    ₹{{fly?.fare[0]?.baseFare+fly?.fare[0]?.finalTax+fly?.fare[0]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{fly.fare[0]?.netFare}}</span>
                                   
                                    </span> 
  
                                  </span>        
                                   
                                    
                                  </div>
                                   
                                </div>
                                 <div class="col-md-12 row" >
                                      <span class="col-md-1 "></span>
                                      <span class="col-md-6 d-flex justify-content-center" *ngIf="fly?.fare[0]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 10px;">{{fly?.fare[0]?.refundable===true?('Refundable'):''}}</span>
                                      <span class="col-md-6 d-flex justify-content-center" *ngIf="fly?.fare[0]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 10px;"> {{fly?.fare[0]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                                      <span class="col-md-1 "></span>
                                      <span class="col-md-3 d-flex justify-content-center" *ngIf="fly?.fare[0]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 10px;">{{fly?.fare[0]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                                      <span class="col-md-3 d-flex justify-content-center" *ngIf="fly?.fare[0]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 10px;">{{fly?.fare[0]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                                    </div>
                                <div *ngIf="fly?.fare[0]" class="col-md-12 bold row"style="padding-left: 23px;padding-top: 4px;">
  
                                  <span (click)="setStep(0)" color="primary" >
                                    {{fly?.fare[0].fareTypeDisplay}} <span *ngIf="Incv" style="color: grey;font-size: 14px;">&nbsp; Incv ₹{{fly?.fare[0]?.incentiveAmt}}</span>
                                  </span>                       
                                </div> 
  
                                   </div>
                          <div  class="col md-6 row " [style]="fly?.fare[1]?.fareType==='Corporate Fare'?('background-color:#CBFFCB;border-radius: 15px;'):''||fly?.fare[1]?.fareType==='Corporate'?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''||fly?.fare[1]?.corporateFare?('background-color:#CBFFCB;border-radius: 15px;margin-right:2px'):''">
                                <div  *ngIf="fly?.fare[1]" class="col-md-12 row">
                                  <div (click)="setStep(0)" class="col-md-6" style="padding-left: 20px;padding-top: 4px; padding-bottom: 4px;">
                                    <span *ngIf="!enableCheck" (click)="onClickFare(fly?.fare[1], fly?.fare,fly)" >
  
                                    <mat-icon class="mat-primary" *ngIf="fly?.fare[1].selected==='true'">radio_button_checked</mat-icon>
                                    <mat-icon  style="color: #757575;" *ngIf="fly?.fare[1].selected===''">radio_button_unchecked</mat-icon>
                                    
                                    
                                    <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popover1Content" container="body"
                                    triggers="mouseenter:mouseleave">
                                    ₹{{fly?.fare[1]?.baseFare+fly?.fare[1]?.finalTax+fly?.fare[1]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{fly?.fare[1]?.netFare}}</span>
                                   
                                  
                                  </span>
                                    </span>
                                    <span *ngIf="enableCheck" >
  
                                      
                                      
                                      <span style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popover1Content" container="body"
                                      triggers="mouseenter:mouseleave">
                                      ₹{{fly?.fare[1]?.baseFare+fly?.fare[1]?.finalTax+fly?.fare[1]?.commercialData?.finalAmount}} <span *ngIf="net" style="color: grey;font-size: 14px;">&nbsp; Net ₹{{fly?.fare[1]?.netFare}}</span>
                                      
                                      </span> 
                                      </span>
                                     
                                     
                                  </div>
                                  <div class="col-md-12 row">
                                    <span class="col-md-1 "></span>
                                    <span class="col-md-6 d-flex justify-content-center" *ngIf="fly?.fare[1]?.refundable===true" style="color:white ;background-color: rgb(93, 93, 152); border-radius: 4px ;padding: 4px; font-size: 11px;">{{fly?.fare[1]?.refundable===true?('Refundable'):''}}</span>
                                    <span class="col-md-6 d-flex justify-content-center" *ngIf="fly?.fare[1]?.refundable===false" style="color:white ;background-color: hsl(0, 89%, 65%); border-radius: 4px ;padding: 4px;font-size: 11px;"> {{fly?.fare[1]?.refundable===false?('Non&nbsp;Refundable'):''}}</span>
                                    <span class="col-md-1 "></span>
                                    <span class="col-md-3 d-flex justify-content-center" *ngIf="fly?.fare[1]?.hasFreeMeal===true" style="color:white;background-color: rgb(178, 178, 19);; border-radius: 4px ;padding: 4px;font-size: 11px;">{{fly?.fare[1]?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                                    <span class="col-md-3 d-flex justify-content-center" *ngIf="fly?.fare[1]?.hasFreeMeal===false" style="color:white ;background-color: hsl(0, 89%, 65%);border-radius: 4px ;padding: 4px;font-size: 11px;">{{fly?.fare[1]?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
                                  </div>
                                </div>
                                
                                <div  *ngIf="fly?.fare[1]" class="col-md-12 bold row" style="padding-left: 23px;padding-top: 4px;">
                                  <span  (click)="setStep(0)" color="primary" > 
                                    {{fly?.fare[1]?.fareTypeDisplay}} <span *ngIf="Incv" style="color: grey;font-size: 14px;">&nbsp; Incv ₹{{fly?.fare[1]?.incentiveAmt}}</span>
  
                                  </span>
                                </div> 
  
                                 
                          </div>
                      <ng-template #popoverContent class="col-md-12"  >
                    <div class="  col-md-12 ">
  
                    <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                                  style="overflow-y:scroll;max-height: 95%; width: 100%;">
                                  <thead class="thead-light" style="white-space:nowrap;">
                                    <tr>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                      <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                      <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                    </tr>
                                  </thead>
                                  <tbody >
                                    <tr  style="height: 25px; ">
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0].baseFare}}</td>
                                    
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0].finalTax}}</td>
                                     
  
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.value}}</td>
                                    
                                    
                                    </tr>
                                  </tbody>
                                </table>
                                <!-- <div class=" mt-1" *ngIf="messageData.adultCount">
                                  <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                                   <span> {{passengerTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                                    
                                  </span>
                                  
                               
                              </div>
                              <div class=" mt-1" *ngIf="messageData.childCount">
                                <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                                <span> {{passengerCTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                                 
                                </span>
                                
                             
                            </div>
                            <div class=" mt-1" *ngIf="messageData.infantCount">
                              <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                              <span> {{passengerITypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(item?.flight?.fare[0],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                                            
                              </span>
                              
                           
                          </div> -->
  
                    </div>
                    </ng-template>
                    <ng-template #popover1Content class="col-md-12"  >
                      <div class="  col-md-12 ">
                      
                      <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                                    style="overflow-y:scroll;max-height: 95%; width: 100%;">
                                    <thead class="thead-light" style="white-space:nowrap;">
                                      <tr>
                                        <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                        <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                        <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                        <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
                      
                      
                      
                                      </tr>
                                    </thead>
                                    <tbody >
                                      <tr  style="height: 25px; ">
                                       
                                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[1].baseFare}}</td>
                                      
                                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[1].finalTax}}</td>
                                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                        <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.value}}</td>
                                      
                                      
                                      
                                      </tr>
                                    </tbody>
                                  </table>
                                 
                                <!-- <div class=" mt-1" *ngIf="messageData.adultCount">
                                  <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                                   <span> {{passengerTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                  
                                            
                                  </span>
                                  
                               
                              </div>
                              <div class=" mt-1" *ngIf="messageData.childCount">
                                <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                                <span> {{passengerCTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                  
                                             
                                </span>
                                
                             
                            </div>
                            <div class=" mt-1" *ngIf="messageData.infantCount">
                              <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                              <span> {{passengerITypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareMapping(item?.flight?.fare[1],item,item?.flight?.fare)))[0]?.fareBasis):''}}
                  
                                             
                              </span>
                              
                           
                          </div> -->
                      
                      </div>
                      </ng-template>
                      
  
                    </div>
                    <div class="col-md-2 " style="padding-top: 33px;" *ngIf="!enableCheck&&fly.itineraries.length===(in+1)">
                      <span *ngIf="tripEnable===false">
                      <button *ngIf="!showSpiner &&!fly?.selected "  mat-raised-button color="accent"   disabled >
                        Book
                      </button> 
                      <button *ngIf="!showSpiner && fly?.selected"  mat-raised-button color="accent"  (click)="openWindow(item)"  >
                        Book
                      </button> 
                       
                      <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>
                    </span>
                    <span *ngIf="tripEnable===true">
                      <button *ngIf="!showSpiner &&!fly?.selected "  mat-raised-button color="accent"   disabled >
                        Select Flight
                      </button> 
                      <button *ngIf="!showSpiner && fly?.selected"  mat-raised-button color="accent"  (click)="openWindow(item)"  >
                        Select Flight
                      </button> 
                       
                      <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select Flight</button>
                    </span>
                  <span style="position: relative; right:1%;top:10%">
                      <button *ngIf="fly?.dropDown===false" mat-icon-button  (click)="selectFlight(fly);onClickDepartureDown(fly)">
                        <mat-icon style=" color:grey;"  class="mb-3">expand_more</mat-icon>
                      </button>
                    
                      <button *ngIf="fly?.dropDown===true" mat-icon-button  (click)="onClickDepartureUp(fly)">
                        <mat-icon style=" color:grey;"  class="mb-3">expand_less</mat-icon>
                      </button></span>
                     
                  </div>
                </div>
               
          </div>
          </mat-panel-title>
        
        
          
      </mat-expansion-panel-header>
      <!-- *ngIf="item?.flight?.dropDown===true" -->
      <div   class="col-md-12 row" *ngIf="fly?.dropDown===true&&fly.itineraries.length===(in+1)">
        <table class="styled-tables ">
          <thead>
            <tr  >
              <!-- Dynamic headers based on tableHeaders array -->
              <th style="padding: 8px;  text-align: center;text-align: left;">FARE TYPE</th>
              <th style="padding: 8px;  text-align: center;text-align: left;">CANCELLATION</th>
              <!-- <th style="padding: 8px;  text-align: center;">DATE CHANGE</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">MEAL</th>
              <!-- <th style="padding: 8px;  text-align: center;text-align: left;">SEAT</th> -->
              <!-- <th style="padding: 8px;  text-align: center;text-align: left;">CHECK-IN</th> -->
              <th style="padding: 8px;  text-align: center;text-align: left;">CABIN BAG</th>
              <th style="padding: 8px;  text-align: center;text-align: left;"></th>
  
            </tr>
          </thead>
          <tbody class="box-shadow">
            <!-- Iterate through dynamic data rows -->
            <tr  *ngFor="let fare of fly?.fare;" >
              <!-- Display structured data -->
              
              <td class=" " style="padding: 8px; " [style]="fare.corporateFare?('color: #017BFE;font-weight:700'):'' ||fare.fareType==='Corporate Fare'?('color: #017BFE;font-weight:700'):'' || fare.fareType==='Corporate'?('color: #017BFE;font-weight:700'):''">
                  <span class="" >
                    <!-- <mat-icon *ngIf="enableCheck" style=" color: #757575;">check_box_outline_blank</mat-icon>
                    <mat-icon *ngIf="false" class="mat-primary">check_box</mat-icon> -->
                    
                      <mat-checkbox color="primary"  *ngIf="enableCheck"  (click)="selectShareData($event,fly,fare)"></mat-checkbox>
  
                    <!-- {{fare?.corporateFare?("Corporate"):fare.fareType }} -->
                    {{fare?.fareTypeDisplay}}
  
                    
                  </span>
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, fly?.fare,fly);openPopup(fly,fare);onClickITINERARYTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>  
                <br><small *ngIf="parentType==='Staff'" style="color: rgb(194, 129, 8);">{{fare?.source}}</small>  
              </td>
              <td class="" style="padding: 8px;">
                <!-- <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===true" >{{fare?.refundable===true?('Refundable'):''}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.refundable===false" > {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}</span> -->
                {{fare?.refundable===true?('Refundable'):''}}
                {{fare?.refundable===false?('Non&nbsp;Refundable'):''}}
                <span class="" style="color:rgba(127, 127, 128, 0.544);cursor: pointer;"  (click)="onClickFare(fare, fly?.fare,fly);openPopup(fly,fare);onClickCancellationTab()"><mat-icon style="font-size: 20px;">info</mat-icon></span>    
  
              </td>
              
              <td class="" style="padding: 8px;">
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===true" >{{fare?.hasFreeMeal===true?('Free&nbsp;Meal'):""}}</span>
                <span class=" d-flex justify-content-start" *ngIf="fare?.hasFreeMeal===false" >{{fare?.hasFreeMeal===false?('Paid&nbsp;Meal'):""}}</span>
              
              </td>
              <!-- <td class="name-type" style="padding: 8px;">
                {{fareOMapping(fare,item,item?.flight?.fare)[0]?.seatsAvailability}}
                
  
              </td> -->
              <!-- <td class="" style="padding: 8px;">{{ '' }}</td> -->
              <!-- <td class="" style="padding: 8px;">
                 {{fareOMapping(fare,item,item?.flight?.fare)[0]?.baggageInfo?.value?(fareOMapping(fare,item,item?.flight?.fare)[0]?.baggageInfo?.value +(fareOMapping(fare,item,item?.flight?.fare)[0]?.baggageInfo?.unit==='Kilograms'?("KG"):fareOMapping(fare,item,item?.flight?.fare)[0]?.baggageInfo?.unit==='Piece'?("PC"):'')):"N/A"}}
              </td> -->
              <td class="" style="padding: 8px;">{{'7KG'}}</td>
              <td  style="padding: 8px;">
               <span class="bold d-flex justify-content-end" style="color:rgb(1,123,254);cursor: pointer;font-weight:600; ;font-size: 17px;" [ngbPopover]="popoverContent" container="body"
               triggers="mouseenter:mouseleave">
               <span *ngIf="Incv" style="color: grey;font-size: 14px;"> Incv ₹{{fare?.incentiveAmt}}&nbsp;&nbsp;</span>
               <span *ngIf="net" style="color: grey;font-size: 14px;">  Net ₹{{fare?.netFare}}&nbsp;&nbsp;</span> 
  
                ₹{{fare?.baseFare+fare?.finalTax+fare?.commercialData?.finalAmount}} <br>
               
               
                
              </span>
               <div *ngIf="enableCheck" style="min-height: 5vh;"></div>
               <span *ngIf="tripEnable===false">
  
                <button  *ngIf="!showSpiner&&!enableCheck" class="col-md-12 bold"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;" (click)="onClickFare(fare, fly?.fare,fly);openWindow(fly)"  >
                  Book
                </button>  
                <button  *ngIf="showSpiner&&!enableCheck" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;"  >Book</button>
               </span>
               <span *ngIf="tripEnable===true">
  
                <button *ngIf="!showSpiner&&!enableCheck" class="col-md-12 bold"  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;" (click)="onClickFare(fare, fly?.fare,item);openWindow(fly)"  >
                  Select Flight
                </button>  
                <button  *ngIf="showSpiner&&!enableCheck" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100%;"  >Select Flight</button>
               </span>
                <ng-template #popoverContent class="col-md-12"  >
                  <div class="  col-md-12 ">
  
                  <table class="table table-sm table-striped  c-table-hover ml-0 mr-0 mb-0 mt-0"
                                style="overflow-y:scroll;max-height: 95%; width: 100%;">
                                <thead class="thead-light" style="white-space:nowrap;">
                                  <tr>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                                    <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                                    <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                                  </tr>
                                </thead>
                                <tbody >
                                  <tr  style="height: 25px; ">
                                   
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.baseFare}}</td>
                                  
                                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fare.finalTax}}</td>
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                                    <td class="small  mb-0 mt-0 pl-0 pb-0" >{{fly?.fare[0]?.commercialData?.Fee?.value}}</td>
                                  
                                  
                                  
                                  </tr>
                                </tbody>
                              </table>
                              <div class=" mt-1" *ngIf="messageData.adultCount">
                                <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                                 <span> {{passengerTypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis?((passengerTypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis):''}}
                
                             
                                </span>
                                
                             
                            </div>
                            <div class=" mt-1" *ngIf="messageData.childCount">
                              <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                              <span> {{passengerCTypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis?((passengerCTypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis):''}}
                
                              
                              </span>
                              
                           
                          </div>
                          <div class=" mt-1" *ngIf="messageData.infantCount">
                            <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
                            <span> {{passengerITypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareOMapping(fare,item,item?.flight?.fare))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis?((passengerITypeMapping(fareOMapping(fare,item,item?.flight?.fare)))[0]?.fareBasis):''}}
                
                
                            </span>
                            
                         
                        </div>
  
                  </div>
                  </ng-template>
              </td>
  
            </tr>
          </tbody>
        </table>
       
      </div>
    
      
    </mat-expansion-panel>
  </mat-accordion>
</span>
<!-- </cdk-virtual-scroll-viewport> -->
  </div>
  </span>
  
  
  </div>
  </div>
  <!--###################################  pendingFlight.gif ##################################################
       ################################### pendingFlight.gif  ################################################## 
        ################################### pendingFlight.gif ##################################################-->
        <div *ngIf="!showPending&&blankList" class=" no-result-container " style="padding: 1.3rem;text-align: center;background-color: antiquewhite;">
          <div class="icon">
            <!-- Use an SVG or FontAwesome icon for the magnifying glass -->
            <!-- <img src="assets/images/" alt="No Result Icon"> -->
          </div>
          <h2>No Result Found</h2>
          <p>Sorry, there are no matching results</p>
        </div>
        <div *ngIf="showPending" >
    <div class="gif-container">
      <img src="../../../assets/images/pendingFlight.gif" >
  </div>
  </div>
  
  
  <!--###################################  flightDetails ##################################################
       ################################### flightDetails  ################################################## 
        ################################### flightDetails ##################################################-->
        
          
      
  <div class="modal" id="myMod" [style.display]="!flightDetails ? 'block' : 'none'" >
    <div class="modal-dialog" >
        <div class="modal-content " >
            <div class="modal-header title">
              <h4 class="modal-title">Flight Details</h4>
              <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
              </div>
              <div class="modal-body"  *ngIf="returnflight">
                <div class="mb-3 mt-1" style="white-space:nowrap;">
                <span  *ngFor="let popupItem of popupData;let i=index" >  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( popupItem?.fromAirport)}} to {{cityFilter(popupItem?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon> <span *ngIf="i<popupData.length-1">|</span></span>
              </div>
                <mat-tab-group #tabGroup  mat-stretch-tabs="false" mat-align-tabs="start" style="overflow: auto; max-height: 50vh;">
                  <mat-tab  label="ITINERARY" >  
<div class="mt-4"></div>
<span *ngFor="let popupItem of popupData;let i=index" >
  <div  class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
    <span class="panel-swap  ">  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( popupItem?.fromAirport)}} to {{cityFilter(popupItem?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon></span></div>
      <div class="col-md-12 mt-2 mb-4 row " *ngFor="let element of popupItem.flightDetailsList">
        
        <div class="mb-3 mt-1">
          <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter(element?.fromAirport)}} to {{cityFilter(element?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon>, {{dateFormate(element.schDepartureTime)}}
      </div><br>
    <div class="col-md-2">
      <img  [src]="flightlogoFilter(element?.carrierName)" width="30" height="50" alt="">
  
    
  <br>
  {{fligthNameFilter(element?.carrierName)}}<br>
      <span style="font-size: 13px; color: grey;">{{element?.carrierName}}-{{element?.flightNumber}}
        <br>  <img *ngIf="element?.equipmentType" width="18" height="18" src="https://img.icons8.com/external-soft-fill-juicy-fish/60/external-jet-aerospace-engineering-soft-fill-soft-fill-juicy-fish-2.png" />
        <span style="padding-left: 4px;">{{element?.equipmentType}}</span><br>
      
      <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='Y'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.economy/1000).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='W'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.premiumEconomy/1000).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='F'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.first/1000).toFixed()+' Kg'):'-'}}</span> 
        <span class="bold" *ngIf="messageData?.airSearchRequestBaseDetails[0]?.requestedClass==='C'">{{element?.carbonEmission?.emission?('CO2 '+(element?.carbonEmission?.emission?.business/1000).toFixed()+' Kg'):'-'}}</span> 
        <br><span class="bold" style="padding-left: 6px;" *ngIf="element.distance"> <mat-icon style="font-size: large;">location_on</mat-icon>{{element?.distance?(element?.distance+(element?.unit?(element?.unit):' Miles')):''}}</span>
  
      </span>
  </div>
  
  <div class="col-md-2">
      {{element?.fromAirport}}&nbsp;{{element?.schDepartureTime | date:'HH:mm'}}
      <br>
      <span style="font-size: 12px;white-space:nowrap;">{{dateFormate(element.schDepartureTime)}}</span>
      <br>
      <span style="font-size: 10px;">{{airPortFilter(element.fromAirport)}}, {{element.fromTerminal?("Terminal "+element.fromTerminal):''}}</span>
  </div>
  <div class="col-md-2">
      <span style="font-size: 30px;">&nbsp;&nbsp;&nbsp;&nbsp;⌚</span>
      <br>
      <span style="font-size: 12px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{converter(element.travelDuration)}}</span>
     
  </div>
  <div class="col-md-2">
    {{element.toAirport}}&nbsp;{{element.schArrivalTime | date:'HH:mm'}}
      <br>
      <span style="font-size: 12px; white-space:nowrap;">{{dateFormate(element.schArrivalTime)}}</span>
      <br>
      <span style="font-size: 10px;">  {{airPortFilter(element.toAirport)}},{{element.toTerminal?("Terminal "+element.toTerminal):''}}</span>
  </div>
  <div class="col-md-2">
          
     
  </div>
  <div class="col-md-2">
      
   </div>

   
      </div>
     
  </span>
      
 
      </mat-tab>
      <mat-tab  label="FARE" >
        <div class="mt-4"></div>
        <span *ngFor="let popupItem of popupData;let i=index" >
          <div  class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
            <span class="panel-swap  ">  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( popupItem?.fromAirport)}} to {{cityFilter(popupItem?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon></span></div>
        <span  class="col-md-12 mt-2 mb-2 row">
  
        
        <div class="col-md-5 ">
  
        <table class="table table-sm table-striped table-bordered c-table-hover ml-0 mr-0 mb-0 mt-0"
                  style="overflow-y:scroll;max-height: 95%; width: 100%;">
                  <thead class="thead-light" >
                    <tr>
                      <th class="small font-weight-bold w-20 small" style="width: 180px;">BASE</th>
                      <th class="small font-weight-bold w-20 small" style="width: 180px;">AIRLINE TAX</th>
                      <th class="small font-weight-bold w-20 small" style="width: 180px;">GST</th>
                      <th class="small font-weight-bold w-40 small" style="width: 180px;" >MGMT FEE</th>
  
  
  
                    </tr>
                  </thead>
                  <tbody >
                    <tr  style="height: 25px; ">
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{popupItem?.fare[0]?.baseFare}}</td>
                     
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{popupItem?.fare[0]?.finalTax}}</td>
                     
  
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{popupItem?.fare[0]?.commercialData?.Fee?.taxes[0].amount}}</td>
                      <td class="small  mb-0 mt-0 pl-0 pb-0" >{{popupItem?.fare[0]?.commercialData?.Fee?.value}}</td>
                    
                    
                    
                    </tr>
                  </tbody>
                </table>
                <div class=" mt-1" *ngIf="messageData.adultCount">
                  <span class="bold">{{messageData.adultCount?(messageData.adultCount+'x'+'Adult:'):''}}</span>
                   <span> {{passengerTypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerTypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerTypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis?((passengerTypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis):''}}
  
  
                    (<span *ngFor="let entry of getObjectKeysAndValues(passengerTypeMapping((fareTypeMapping(popupItem)))[0]?.fareDetailsPerPassengerType?.taxes)">
                      {{ entry.key }}{{ entry.value | json }},
                     </span>)
                  </span>
                  
               
              </div>
              <div class=" mt-1" *ngIf="messageData.childCount">
                <span class="bold">{{messageData.childCount?(messageData.childCount+'x'+'Child:'):''}}</span>
                <span> {{passengerCTypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerCTypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerCTypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis?((passengerCTypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis):''}}
  
  
                  (<span *ngFor="let entry of getObjectKeysAndValues(passengerCTypeMapping((fareTypeMapping(popupItem)))[0]?.fareDetailsPerPassengerType?.taxes)">
                    {{ entry.key }}{{ entry.value | json }},
                   </span>)
                </span>
                
             
            </div>
            <div class=" mt-1" *ngIf="messageData.infantCount">
              <span class="bold">{{messageData.infantCount?(messageData.infantCount+'x'+'Infant:'):''}}</span>
              <span> {{passengerITypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare?(passengerITypeMapping(fareTypeMapping(popupItem))[0]?.fareDetailsPerPassengerType?.baseFare):''}} {{(passengerITypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis?((passengerITypeMapping(fareTypeMapping(popupItem)))[0]?.fareBasis):''}}
  
  
                (<span *ngFor="let entry of getObjectKeysAndValues(passengerITypeMapping((fareTypeMapping(popupItem)))[0]?.fareDetailsPerPassengerType?.taxes)">
                  {{ entry.key }}{{ entry.value | json }},
                 </span>)
              </span>
              
           
          </div>
              </div>
              <div  class="col-md-7" >
                <mat-progress-bar *ngIf="popupItem.farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>
  
                <div style="height:40vh; overflow: auto;"  *ngIf="popupItem.json">
               <div  *ngFor="let item of popupItem.json" >
                <div class="col-md-12 title bold" style="text-align: center; padding: 4px; font-size: 14px;">{{ item?.key }}</div>
                
                <div class="col-md-12"><pre [innerHTML]="item?.value">{{ item?.value}} </pre></div>
  
                </div>
              </div>
              </div>
            </span>
            </span>
             
          
        </mat-tab>
        <mat-tab  label="Cancellation"  >
          <div class="mt-4"></div>
          <span *ngFor="let popupItem of popupData;let i=index" >
            <div  class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
              <span class="panel-swap  ">  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( popupItem?.fromAirport)}} to {{cityFilter(popupItem?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon></span></div>
        
          <div  class="col-md-12 mt-2"  >
            <mat-progress-bar *ngIf="popupItem.farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>
  
            <div style="height:40vh; overflow: auto;"  *ngIf="popupItem.json && !popupItem?.routeRequest?.localFareRules">
           <div  *ngFor="let item of popupItem.json" >
            <div *ngIf="item?.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item?.key }}</div>
            
            <div *ngIf="item?.key==='PENALTIES'" class="col-md-12"><pre >{{ item?.value}} </pre></div>
  
            </div>
          </div>
          <div *ngIf="popupItem?.routeRequest?.localFareRules">
            
  
            <table class="styled-popup-tables ">
              <thead>
                <tr  >
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee  <small class="grey"> (Per passenger)</small></th>
                 
                </tr>
              </thead>
              <tbody class="grey">
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(popupItem)[0]?.otherData?.fareRule?.config?.cancellationRuleTxt)?.schedule">
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    
                    </td>
  
                </tr>
              </tbody>
            </table>
  
            
  
  
  
  
  
  
            
           </div>
          </div>
          </span>
          
        </mat-tab>
  
  
        <mat-tab  label="Date Change">
          <div class="mt-4"></div>
          <span *ngFor="let popupItem of popupData;let i=index" >
            <div  class="card " style="border-bottom: transparent;border-left: transparent;border-right: transparent; border-radius: 0;">
              <span class="panel-swap  ">  <mat-icon matSuffix>flight_takeoff</mat-icon>  {{cityFilter( popupItem?.fromAirport)}} to {{cityFilter(popupItem?.toAirport)}}  <mat-icon matSuffix>flight_land</mat-icon></span></div>
        
          <div  class="col-md-12 mt-2" >
            <mat-progress-bar *ngIf="popupItem.farejson.fareRules==='pending'" mode="indeterminate"></mat-progress-bar>
  
            <div style="height:40vh; overflow: auto;"  *ngIf="popupItem.json && !popupItem?.routeRequest?.localFareRules">
           <div  *ngFor="let item of popupItem.json" >
            <div *ngIf="item?.key==='PENALTIES'" class="col-md-12 title bold" style="text-align: left; padding: 4px; font-size: 14px;">{{ item?.key }}</div>
            
            <div *ngIf="item?.key==='PENALTIES'" class="col-md-12"><pre>{{ item?.value}} </pre></div>
  
            </div>
          </div>
          <div *ngIf="departureFlight?.routeRequest?.localFareRules">
           
  
            <table class="styled-popup-tables ">
              <thead>
                <tr  >
                  <th style="padding: 8px;  text-align: center;text-align: left;">Time frame <small class="grey">(From Scheduled flight departure) </small></th>
                  <th style="padding: 8px;  text-align: center;text-align: left;">Airline Fee + Gilpin Fee <small class="grey"> (Per passenger)</small></th>
                 
      
                </tr>
              </thead>
              <tbody class="grey">
                <tr   *ngFor="let schedule of convertjson(fareTypeMapping(popupItem)[0]?.otherData?.fareRule?.config?.changeRuleTxt)?.schedule">
                  
                 
                  <td class="" style="padding: 8px;">{{scheduleFilter(schedule?.from) }} {{schedule?.to==='999:h'?('& Beyond'):schedule?.to?('to'):''}} {{ schedule?.to==='999:h'?(''):scheduleFilter(schedule?.to) }} </td>
                  
                  <td class="" style="padding: 8px;">
                    <span *ngIf="messageData?.adultCount>0">{{schedule?.adult?('ADULT: ' +filterCharges(schedule?.adult?.charges)):'' }} <mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.adult?.charges[0].description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.childCount>0"> {{schedule?.child?(', CHILD: '+filterCharges(schedule?.child?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.child?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    <span *ngIf="messageData?.infantCount>0"> {{ schedule.infant?(', INFANT: '+filterCharges(schedule?.infant?.charges)):'' }}<mat-icon style="font-size: 14px;cursor: pointer;" [pTooltip]="schedule?.infant?.charges[0]?.description" tooltipPosition="top">info</mat-icon></span>
                    
                    </td>
  
                </tr>
              </tbody>
            </table>
  
            
  
  
  
  
  
  
            
           </div>
          </div>
          </span>
         
        </mat-tab>
  
      </mat-tab-group>
                <div class="modal-footer">
                  <div class="form-group form-inline ">
                    <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                  </div>   
                 
                      <span style="font-size: 18px; font-weight: bold;color: rgb(33,33,33);"> ₹ {{returnFlight?.fare[0]?.baseFare+ returnFlight?.fare[0]?.finalTax+returnFlight?.fare[0]?.commercialData?.finalAmount+departureFlight?.fare[0]?.baseFare+departureFlight?.fare[0]?.finalTax+departureFlight?.fare[0]?.commercialData?.finalAmount}}</span>
  
                <span *ngIf="userType!='EMPLOYEE'">
                    <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openWindow({})" >
                    Book
                  </button>   
                  <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Book</button>
  
                  </span> 
                  <span *ngIf="userType==='EMPLOYEE'">
                    <button *ngIf="!showSpiner" mat-raised-button color="accent" (click)="openWindow({})" >
                      Select Flight
                  </button>   
                  <button  *ngIf="showSpiner" disabled  mat-raised-button color="accent" style="margin-right: 2%; width: 100px;"  >Select Flight</button>
  
                  </span> 
                </div>
              </div>
              </div>
      </div>
  </div>
  
  
  <!--###################################  Email  ##################################################
       ################################### Email  ################################################## 
        ################################### Email ##################################################-->
       
        <div class="modal" id="myMod" [style.display]="sharePopup ? 'block' : 'none'" >
          <div class="modal-dialog" >
              <div class="modal-content " >
                  <div  class="modal-header title sticky-tabsahre">
                    <h4 *ngIf="!viewData" class="modal-title"> Search Results
                    </h4>
                    <h4 *ngIf="viewData" class="modal-title">Fare Quotations</h4>
                    <button *ngIf="viewData" mat-flat-button  style="font-size: medium;color: white; background-color: rgb(1,123,254);" class="close" data-dismiss="modal" (click)="copyToClipboard()">Copy Text</button>
  
                    <button *ngIf="!viewData" type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                    <button *ngIf="viewData" type="button" class="close" data-dismiss="modal" (click)="closeviewData()">&times;</button>
  
                    </div>
                    <div class="modal-body"  >
  
                      <table *ngIf="!viewData" class="share-tables " >
                        
                        <tbody class="">
                          <tr   >
                            
                            <td class="tdTitle " style="padding: 4px; ">Add User</td>
                            <td class="" style="padding: 4px;" >
                              <div class="row">
  
                              <mat-form-field class="col-md-7 " appearance="outline"style="margin-bottom:-20px">
            
                                <mat-chip-grid #chipGrids aria-label="city Selection">
                                </mat-chip-grid>
                                <div class="input-with-icon col-md-12">
                                <input  #travellerInput [formControl]="traveller" 
                                  [matChipInputFor]="chipGrids" [matAutocomplete]="autoTo"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodesTo"
                                  (matChipInputTokenEnd)="addTo($event)"
                                  />
                                  <mat-icon>arrow_drop_down</mat-icon>
                                </div>
                  
                                <mat-autocomplete #autoTo="matAutocomplete" (optionSelected)="selectedTo($event)">
                                  <mat-option value="" *ngIf="usersList?.length===0">{{'Traveller Not Found'}}</mat-option>
                                  <mat-option  *ngFor="let item of filteredTo | async" [value]="item?.username"  (click)="onfilterClick(item.flight?.username)">
                                    
                                    {{item?.firstName?(item?.firstName+';'):''}}{{item?.username}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                           <div class=" col-md-5 d-flex justify-content-start pt-2" style=" border-left: 1px solid #d2e1f5;" >
                              <button mat-raised-button (click)="onClickTo()" style="margin-right: 8px; margin-left: 8px;"><mat-icon>add</mat-icon>Add-To</button>
                              <button  mat-raised-button  (click)="onClickCC()"><mat-icon>add</mat-icon>Add-CC</button>
                            </div>
                          </div>
  
                            </td>
                           
  
                          </tr>
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">To</td>
                            <td class=" " style="padding: 4px; ">
                              <textarea class="form-control"  [(ngModel)]="addTO" name="to"  cols="60" rows="1"></textarea>
                            </td>
                          </tr>
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">CC</td>
                            <td class=" " style="padding: 4px; ">
                              <textarea class="form-control " [(ngModel)]="addCC" name="cc"  cols="60" rows="1"></textarea>
                            </td>
                          </tr>
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">Reply-To	</td>
                            <td class=" " style="padding: 4px; ">
                              <input class="form-control"  type="text"> 
                            </td>
                          </tr>
                         
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">Format	</td>
                            <td class=" " style="padding: 4px; " >
                              <button  *ngIf="!SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''"  (click)="onClickTitle('view')">View Text</button>
                              <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='view'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('view')">View Text</button>
                              <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                              <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='email'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('email')" >Email</button>
                             <button *ngIf="!SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>
                                  <button *ngIf="SelectedView" mat-raised-button [style]="viewText==='excel'?('background-color:#43a8c4;color:white'):''" (click)="onClickTitle('excel')" >Excel Download</button>
  
  
  
                            </td>
                          </tr>
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">Subject</td>
                            <td class=" " style="padding: 4px; " >
                              <input class="form-control " [(ngModel)]="subjectEmail"  name="subject"  >
  
  
  
                            </td>
                          </tr>
                          <tr>
                            <td class="tdTitle " style="padding: 4px; ">Greeting Message	</td>
                            <td class=" " style="padding: 4px; " >
                              <textarea class="form-control "  name="Message"  cols="60" rows="4"></textarea>
  
  
  
                            </td>
                          </tr>
                        </tbody>
                      </table>
                   <div *ngIf="fetchAllData && viewData"class="row" >
                    
                  <div  class="col-md-5">
  
                    <pre>{{allEmailData}}</pre>
  
                   </div>
                   <div *ngIf="messageData.journeyType==='return'"  class="col-md-5">
  
                     <pre>{{allInboundEmailData}}</pre>
  
                   </div>
                    </div>
                  </div>
  
                    <div class="modal-footer" *ngIf="!viewData">
                      <div class="form-group form-inline ">
                        <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                      </div>   
                        <button *ngIf="!SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onClickView()">Send</button>
                        <button *ngIf="SelectedView&&viewText==='view'" class="btn btn-outline-success c-width-100px shadow " (click)="onSelectedkView()">Send</button>
                        <button *ngIf="!SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequest()">Send</button>
                        <button *ngIf="SelectedView&&viewText==='email'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequest()" >Send</button>
                        <button *ngIf="!SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow "  (click)="allRequestDownload()">Excel Download</button>
                        <button *ngIf="SelectedView&&viewText==='excel'" [disabled]="!addTO" class="btn btn-outline-success c-width-100px shadow " (click)="selectedRequestDownload()" >Excel Download</button>
  
                        
                        
                        <button type="button" style="margin-left: 8px;" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                   
                    </div>
  
            </div>
        </div>
      </div>
  
      <span    *ngIf="returnflight&&countdown<180"
      style="background-color: rgb(6, 141, 146);padding: 10px;border-radius: 4px;color: white; position: sticky;bottom:0 ;left:0"  > 
      <span *ngIf="countdown!=0"  style="color: #fff;background-color: rgb(6, 141, 146);"> Search Session will Expire in  - {{convertSecondsToMinSec(countdown)}}</span>
      <span *ngIf="countdown===0" style="color: #fff;background-color: red;"> Search session has been expired  need to Re-Search</span>
    </span>
    
    <button    *ngIf="returnflight"
    (click)="scroll(tops)"  style="background-color: rgb(6, 141, 146);color: white; position: sticky;bottom:0 ;left:100%"   mat-fab><mat-icon style="margin-left: 4px;">expand_less</mat-icon></button>
    
  
    